import type { SonarFunilInputs } from './lib/sonarCalculations'
import type { CPAMaximoInputs } from './lib/cpaCalculations'
import type { PlanejamentoInputs } from './lib/planejamentoCalculations'
import type { MetricasComerciaisInputs } from './lib/metricasComerciaisCalculations'

export type SonarFunilDefaultValues = Omit<SonarFunilInputs, 'mode'>

export const sonarFunilDefaultValues: SonarFunilDefaultValues = {
  investimento: 5000,
  impressoes: 50000,
  cliques: 380,
  pageViews: 280,
  conversasWhatsapp: 168,
  leadsQualificados: 62,
  leadsDesqualificados: 38,
  consultasAgendadas: 18,
  consultasRealizadas: 14,
  vendas: 6,
  ticketMedio: 3500,
}

export type CPAMaximoDefaultValues = Omit<CPAMaximoInputs, 'custosVariaveis'>

export const DEFAULT_LEAD_TO_APPOINTMENT_RATE = 10

export const cpaMaximoDefaultValues: CPAMaximoDefaultValues = {
  precoProduto: 3500,
  taxaPlataformaPercent: 0,
  taxaPlataformaFixo: 0,
  metaVendas: 10,
}

export const planejamentoDefaultValues: PlanejamentoInputs = {
  faturamento: 10000,
  precoProduto: 3500,
  taxaLeadAgendamento: DEFAULT_LEAD_TO_APPOINTMENT_RATE,
  taxaAgendadaRealizada: 70,
  taxaConsultaVenda: 10,
  precoLead: 8,
}

export const metricasComerciaisDefaultValues: MetricasComerciaisInputs = {
  investimento: 3000,
  cpm: 50,
  ctr: 0.6,
  taxaCliqueLead: 35,
  taxaLeadAgendamento: DEFAULT_LEAD_TO_APPOINTMENT_RATE,
  taxaAgendadaRealizada: 70,
  taxaConsultaVenda: 10,
  ticketMedio: 3500,
}
